import request from '@/utils/request'

//内容管理
export function getInfo(params) {
  return request({
    url: '/api/contenfronpagemanage/getInfo',
    method: 'get',
    params
  });
}
//获取官网链接
export function getcontenconnecconfigure(params) {
  return request({
    url: '/api/contenconnecconfigure/list',
    method: 'get',
    params
  });
}
//获取发布的图片
export function getHomePage(params) {
  return request({
    url: '/api/contencarouseldeploy/release/picture/info',
    method: 'get',
    params
  });
}
//入馆人数
export function gateCount(data) {
  return request({
    url: '/api/hengda/gateCount',
    method: 'post',
    data
  });
}
//浏览量
export function viewCount(data) {
  return request({
    url: '/api/contenfronpagemanage/viewCount',
    method: 'get',
    data
  });
}
//浏览量
export function viewCountAdd(data) {
  return request({
    url: '/api/contenfronpagemanage/viewCountAdd',
    method: 'get',
    data
  });
}
//获取分享空间列表--可分页
export function getShareSpaceList(data) {
  return request({
    url: '/api/voluntary/getShareSpaceList',
    method: 'get',
    data
  });
}
// 浏览记录
export function gethistoryList(params) {
  return request({
    url: '/api/exhibition/exhibitionvisitorhistory/listAll',
    method: 'get',
    params
  });
}



// WEBPACK FOOTER //
// ./src/api/index/index.js